import { useNavigate } from "react-router";
import { useLocalStorage } from "usehooks-ts";
import { useShallow } from "zustand/react/shallow";
import { SpinnerLegacy } from "../../../components";
import { SellarMap } from "../../../components/map/SellarMap";
import { useSellarMapStore } from "../../../components/map/SellarMapStore";
import { NavigationBar } from "../../../components/navigation/NavigationBar";
import { DISCOVER } from "../../../constants/routes";
import { useSellarCurrentBusiness } from "../../../hooks/useSellarCurrentBusiness.shared";
import { useDiscoverySupplierList } from "../../../hooks/api/v2/discovery/useDiscoverySupplierList";

export const DiscoveryV2SupplierMap = () => {
  const navigate = useNavigate();
  const { business } = useSellarCurrentBusiness();
  const [unAuthorisedUserLocation] = useLocalStorage<
    { lat: number; lng: number } | undefined
  >("unAuthorisedUserLocation", undefined);

  const supplierListQuery = useDiscoverySupplierList({});

  const suppliers = supplierListQuery.data?.pages.flatMap((page) => page) ?? [];

  const { add, location } = useSellarMapStore(
    useShallow((state) => ({
      add: state.add,
      location: state.location,
    })),
  );

  const businessLocation = business?.Location ?? null;
  const unauthenticatedUserLocation = unAuthorisedUserLocation ?? null;
  if (!location) add(businessLocation ?? unauthenticatedUserLocation);

  return (
    <>
      <NavigationBar
        leftIcon={"CHEVRON_LEFT"}
        onClickLeftIcon={() => {
          navigate(DISCOVER);
        }}
        title={"Suppliers local to you"}
      />
      <div className={"p-4 pb-0"}>
        {supplierListQuery.isSuccess ? (
          <div className={"h-[calc(100vh-100px)]"}>
            <SellarMap entities={suppliers} displaying="supplier" />
          </div>
        ) : (
          <SpinnerLegacy />
        )}
      </div>
    </>
  );
};
